var SensorML_1_0_1_Module_Factory = function () {
  var SensorML_1_0_1 = {
    n: 'SensorML_1_0_1',
    dens: 'http:\/\/www.opengis.net\/sensorML\/1.0.1',
    dans: 'http:\/\/www.w3.org\/1999\/xlink',
    deps: ['XLink_1_0', 'SWE_1_0_1', 'GML_3_1_1', 'IC_2_0'],
    tis: [{
        ln: 'AbstractSMLType',
        bti: 'GML_3_1_1.AbstractFeatureType'
      }, {
        ln: 'ProcessMethodType.Implementation',
        tn: null,
        ps: [{
            n: 'processChain',
            rq: true,
            en: 'ProcessChain',
            ti: '.ProcessChainType'
          }, {
            n: 'implementationCode',
            rq: true,
            en: 'ImplementationCode',
            ti: '.ProcessMethodType.Implementation.ImplementationCode'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Identification.IdentifierList.Identifier',
        tn: null,
        ps: [{
            n: 'term',
            rq: true,
            en: 'Term',
            ti: '.Term'
          }, {
            n: 'name',
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ArrayLink.DestinationIndex',
        tn: null,
        ps: [{
            n: 'ref',
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'InterfaceDefinition',
        tn: null,
        ps: [{
            n: 'serviceLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'applicationLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'presentationLayer',
            ti: '.PresentationLayerPropertyType'
          }, {
            n: 'sessionLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'transportLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'networkLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'dataLinkLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'physicalLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'mechanicalLayer',
            ti: '.LayerPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'DataSourceType.DataDefinition',
        tn: null,
        ps: [{
            n: 'dataBlockDefinition',
            rq: true,
            en: {
              lp: 'DataBlockDefinition',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.DataBlockDefinitionType'
          }, {
            n: 'dataStreamDefinition',
            rq: true,
            en: {
              lp: 'DataStreamDefinition',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.DataStreamDefinitionType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DataSourceType.Values',
        tn: null,
        ps: [{
            n: 'otherAttributes',
            t: 'aa'
          }, {
            n: 'any',
            mno: 0,
            col: true,
            mx: false,
            t: 'ae'
          }]
      }, {
        ln: 'ComponentType',
        bti: '.AbstractComponentType',
        ps: [{
            n: 'method',
            ti: '.MethodPropertyType'
          }]
      }, {
        ln: 'Characteristics',
        tn: null,
        ps: [{
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDataRecord',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'name',
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'TimePosition',
        tn: null,
        ps: [{
            n: 'time',
            rq: true,
            en: {
              lp: 'Time',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Time'
          }, {
            n: 'process',
            rq: true,
            mx: false,
            dom: false,
            en: '_Process',
            ti: '.AbstractProcessType',
            t: 'er'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Positions.PositionList',
        tn: null,
        ps: [{
            n: 'position',
            rq: true,
            col: true,
            ti: '.Position'
          }, {
            n: 'timePosition',
            rq: true,
            ti: '.TimePosition'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'ContactList.Member',
        tn: null,
        ps: [{
            n: 'person',
            rq: true,
            en: 'Person',
            ti: '.Person'
          }, {
            n: 'responsibleParty',
            rq: true,
            en: 'ResponsibleParty',
            ti: '.ResponsibleParty'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ArrayLink.SourceArray',
        tn: null,
        ps: [{
            n: 'ref',
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'Capabilities',
        tn: null,
        ps: [{
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDataRecord',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'name',
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Components.ComponentList',
        tn: null,
        ps: [{
            n: 'component',
            rq: true,
            col: true,
            ti: '.Components.ComponentList.Component'
          }]
      }, {
        ln: 'EventList',
        tn: null,
        ps: [{
            n: 'member',
            rq: true,
            col: true,
            ti: '.EventList.Member'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }]
      }, {
        ln: 'Documentation',
        tn: null,
        ps: [{
            n: 'document',
            rq: true,
            en: 'Document',
            ti: '.Document'
          }, {
            n: 'documentList',
            rq: true,
            en: 'DocumentList',
            ti: '.DocumentList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Keywords',
        tn: null,
        ps: [{
            n: 'keywordList',
            rq: true,
            en: 'KeywordList',
            ti: '.Keywords.KeywordList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Implementation.ImplementationCode.SourceRef',
        tn: null,
        ps: [{
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Schematron',
        tn: null,
        bti: '.RuleLanguageType',
        ps: [{
            n: 'any',
            rq: true,
            mx: false,
            t: 'ae'
          }]
      }, {
        ln: 'TemporalReferenceFrame',
        tn: null,
        ps: [{
            n: 'temporalCRS',
            rq: true,
            en: {
              lp: 'TemporalCRS',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.TemporalCRSType'
          }]
      }, {
        ln: 'History',
        tn: null,
        ps: [{
            n: 'eventList',
            rq: true,
            en: 'EventList',
            ti: '.EventList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Implementation.ImplementationCode.BinaryRef',
        tn: null,
        ps: [{
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractRestrictedProcessType',
        bti: '.AbstractProcessType'
      }, {
        ln: 'AbstractProcessType',
        bti: '.AbstractSMLType',
        ps: [{
            n: 'keywords',
            mno: 0,
            col: true,
            ti: '.Keywords'
          }, {
            n: 'identification',
            mno: 0,
            col: true,
            ti: '.Identification'
          }, {
            n: 'classification',
            mno: 0,
            col: true,
            ti: '.Classification'
          }, {
            n: 'validTime',
            ti: '.ValidTime'
          }, {
            n: 'securityConstraint',
            ti: '.SecurityConstraint'
          }, {
            n: 'legalConstraint',
            mno: 0,
            col: true,
            ti: '.LegalConstraint'
          }, {
            n: 'characteristics',
            mno: 0,
            col: true,
            ti: '.Characteristics'
          }, {
            n: 'capabilities',
            mno: 0,
            col: true,
            ti: '.Capabilities'
          }, {
            n: 'contact',
            mno: 0,
            col: true,
            ti: '.Contact'
          }, {
            n: 'documentation',
            mno: 0,
            col: true,
            ti: '.Documentation'
          }, {
            n: 'history',
            mno: 0,
            col: true,
            ti: '.History'
          }]
      }, {
        ln: 'Identification.IdentifierList',
        tn: null,
        ps: [{
            n: 'identifier',
            rq: true,
            col: true,
            ti: '.Identification.IdentifierList.Identifier'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Algorithm.AlgorithmDefinition.MathML',
        tn: null,
        ps: [{
            n: 'any',
            rq: true,
            mx: false,
            t: 'ae'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Rules',
        tn: null,
        ps: [{
            n: 'rulesDefinition',
            rq: true,
            en: 'RulesDefinition',
            ti: '.ProcessMethodType.Rules.RulesDefinition'
          }]
      }, {
        ln: 'LayerPropertyType',
        ps: [{
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDataRecord',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'category',
            rq: true,
            en: {
              lp: 'Category',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Category'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ProcessChainType',
        bti: '.AbstractPureProcessType',
        ps: [{
            n: 'components',
            rq: true,
            ti: '.Components'
          }, {
            n: 'connections',
            rq: true,
            ti: '.Connections'
          }]
      }, {
        ln: 'SecurityConstraint',
        tn: null,
        ps: [{
            n: 'security',
            rq: true,
            en: 'Security',
            ti: '.Security'
          }]
      }, {
        ln: 'LegalConstraint',
        tn: null,
        ps: [{
            n: 'rights',
            rq: true,
            en: 'Rights',
            ti: '.Rights'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ConnectionsPropertyType',
        tn: 'connectionsPropertyType',
        ps: [{
            n: 'connectionList',
            rq: true,
            en: 'ConnectionList',
            ti: '.AbstractListType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'OnlineResource',
        tn: null,
        ps: [{
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractDerivableComponentType',
        bti: '.AbstractProcessType',
        ps: [{
            n: 'spatialReferenceFrame',
            ti: '.SpatialReferenceFrame'
          }, {
            n: 'temporalReferenceFrame',
            ti: '.TemporalReferenceFrame'
          }, {
            n: 'targetLocation',
            rq: true,
            en: 'location',
            ti: '.Location'
          }, {
            n: 'targetPosition',
            rq: true,
            en: 'position',
            ti: '.Position'
          }, {
            n: 'timePosition',
            ti: '.TimePosition'
          }, {
            n: 'interfaces',
            ti: '.Interfaces'
          }]
      }, {
        ln: 'AbstractPureProcessType',
        bti: '.AbstractRestrictedProcessType',
        ps: [{
            n: 'inputs',
            ti: '.Inputs'
          }, {
            n: 'outputs',
            ti: '.Outputs'
          }, {
            n: 'parameters',
            ti: '.Parameters'
          }]
      }, {
        ln: 'ProcessMethodType.Algorithm',
        tn: null,
        ps: [{
            n: 'algorithmDefinition',
            rq: true,
            en: 'AlgorithmDefinition',
            ti: '.ProcessMethodType.Algorithm.AlgorithmDefinition'
          }]
      }, {
        ln: 'Outputs.OutputList',
        tn: null,
        ps: [{
            n: 'output',
            rq: true,
            col: true,
            ti: '.IoComponentPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'Inputs',
        tn: null,
        ps: [{
            n: 'inputList',
            rq: true,
            en: 'InputList',
            ti: '.Inputs.InputList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Components.ComponentList.Component',
        tn: null,
        ps: [{
            n: 'process',
            rq: true,
            mx: false,
            dom: false,
            en: '_Process',
            ti: '.AbstractProcessType',
            t: 'er'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Parameters.ParameterList',
        tn: null,
        ps: [{
            n: 'parameter',
            rq: true,
            col: true,
            ti: 'SWE_1_0_1.DataComponentPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'ContactInfo.Address',
        tn: null,
        ps: [{
            n: 'deliveryPoint',
            mno: 0,
            col: true
          }, {
            n: 'city'
          }, {
            n: 'administrativeArea'
          }, {
            n: 'postalCode'
          }, {
            n: 'country'
          }, {
            n: 'electronicMailAddress'
          }]
      }, {
        ln: 'ArrayLink.DestinationArray',
        tn: null,
        ps: [{
            n: 'ref',
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'IoComponentPropertyType',
        ps: [{
            n: 'count',
            rq: true,
            en: {
              lp: 'Count',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Count'
          }, {
            n: 'quantity',
            rq: true,
            en: {
              lp: 'Quantity',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Quantity'
          }, {
            n: 'time',
            rq: true,
            en: {
              lp: 'Time',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Time'
          }, {
            n: '_boolean',
            rq: true,
            en: {
              lp: 'Boolean',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Boolean'
          }, {
            n: 'category',
            rq: true,
            en: {
              lp: 'Category',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Category'
          }, {
            n: 'text',
            rq: true,
            en: {
              lp: 'Text',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Text'
          }, {
            n: 'quantityRange',
            rq: true,
            en: {
              lp: 'QuantityRange',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.QuantityRange'
          }, {
            n: 'countRange',
            rq: true,
            en: {
              lp: 'CountRange',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.CountRange'
          }, {
            n: 'timeRange',
            rq: true,
            en: {
              lp: 'TimeRange',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.TimeRange'
          }, {
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDataRecord',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'abstractDataArray',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDataArray',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.AbstractDataArrayType',
            t: 'er'
          }, {
            n: 'observableProperty',
            rq: true,
            en: {
              lp: 'ObservableProperty',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.ObservableProperty'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ComponentArrayType',
        bti: '.AbstractDerivableComponentType',
        ps: [{
            n: 'inputs',
            ti: '.Inputs'
          }, {
            n: 'outputs',
            ti: '.Outputs'
          }, {
            n: 'parameters',
            rq: true,
            ti: '.ComponentArrayType.Parameters'
          }, {
            n: 'components',
            ti: '.Components'
          }, {
            n: 'positions',
            ti: '.Positions'
          }, {
            n: 'connections',
            ti: '.Connections'
          }]
      }, {
        ln: 'DataSourceType.ObservationReference',
        tn: null,
        ps: [{
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ComponentsPropertyType',
        tn: 'componentsPropertyType',
        ps: [{
            n: 'processList',
            rq: true,
            en: 'ProcessList',
            ti: '.AbstractListType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DocumentList.Member',
        tn: null,
        ps: [{
            n: 'document',
            rq: true,
            en: 'Document',
            ti: '.Document'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'AbstractComponentType',
        bti: '.AbstractDerivableComponentType',
        ps: [{
            n: 'inputs',
            ti: '.Inputs'
          }, {
            n: 'outputs',
            ti: '.Outputs'
          }, {
            n: 'parameters',
            ti: '.Parameters'
          }]
      }, {
        ln: 'Keywords.KeywordList',
        tn: null,
        ps: [{
            n: 'keyword',
            rq: true,
            col: true,
            ti: 'Token'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }, {
            n: 'codeSpace',
            an: {
              lp: 'codeSpace'
            },
            t: 'a'
          }]
      }, {
        ln: 'ComponentArrayType.Parameters',
        tn: null,
        bti: '.ParametersPropertyType'
      }, {
        ln: 'Contact',
        tn: null,
        ps: [{
            n: 'person',
            rq: true,
            en: 'Person',
            ti: '.Person'
          }, {
            n: 'responsibleParty',
            rq: true,
            en: 'ResponsibleParty',
            ti: '.ResponsibleParty'
          }, {
            n: 'contactList',
            rq: true,
            en: 'ContactList',
            ti: '.ContactList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Link.Source',
        tn: null,
        ps: [{
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Algorithm.AlgorithmDefinition',
        tn: null,
        ps: [{
            n: 'description',
            en: {
              lp: 'description',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.StringOrRefType'
          }, {
            n: 'mathML',
            ti: '.ProcessMethodType.Algorithm.AlgorithmDefinition.MathML'
          }]
      }, {
        ln: 'Document',
        tn: null,
        ps: [{
            n: 'description',
            rq: true,
            en: {
              lp: 'description',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.StringOrRefType'
          }, {
            n: 'date'
          }, {
            n: 'contact',
            ti: '.Contact'
          }, {
            n: 'format',
            ti: 'Token'
          }, {
            n: 'onlineResource',
            mno: 0,
            col: true,
            ti: '.OnlineResource'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'version',
            ti: 'Token',
            an: {
              lp: 'version'
            },
            t: 'a'
          }]
      }, {
        ln: 'AbstractDerivableProcessType',
        bti: '.AbstractProcessType',
        ps: [{
            n: 'inputs',
            ti: '.InputsPropertyType'
          }, {
            n: 'outputs',
            ti: '.OutputsPropertyType'
          }, {
            n: 'parameters',
            ti: '.ParametersPropertyType'
          }, {
            n: 'method',
            rq: true,
            ti: '.MethodPropertyType'
          }, {
            n: 'components',
            rq: true,
            ti: '.ComponentsPropertyType'
          }, {
            n: 'dataSources',
            ti: '.DataSourcesPropertyType'
          }, {
            n: 'connections',
            rq: true,
            ti: '.ConnectionsPropertyType'
          }]
      }, {
        ln: 'AbstractListType',
        ps: [{
            n: 'otherAttributes',
            t: 'aa'
          }, {
            n: 'any',
            mno: 0,
            col: true,
            mx: false,
            t: 'ae'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'Inputs.InputList',
        tn: null,
        ps: [{
            n: 'input',
            rq: true,
            col: true,
            ti: '.IoComponentPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Rules.RulesDefinition',
        tn: null,
        ps: [{
            n: 'description',
            en: {
              lp: 'description',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.StringOrRefType'
          }, {
            n: 'ruleLanguage',
            mx: false,
            dom: false,
            ti: '.RuleLanguageType',
            t: 'er'
          }]
      }, {
        ln: 'DataSourcesPropertyType',
        tn: 'dataSourcesPropertyType',
        ps: [{
            n: 'dataSourceList',
            rq: true,
            en: 'DataSourceList',
            ti: '.AbstractListType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SensorML',
        tn: null,
        ps: [{
            n: 'keywords',
            mno: 0,
            col: true,
            ti: '.Keywords'
          }, {
            n: 'identification',
            mno: 0,
            col: true,
            ti: '.Identification'
          }, {
            n: 'classification',
            mno: 0,
            col: true,
            ti: '.Classification'
          }, {
            n: 'validTime',
            ti: '.ValidTime'
          }, {
            n: 'securityConstraint',
            ti: '.SecurityConstraint'
          }, {
            n: 'legalConstraint',
            mno: 0,
            col: true,
            ti: '.LegalConstraint'
          }, {
            n: 'characteristics',
            mno: 0,
            col: true,
            ti: '.Characteristics'
          }, {
            n: 'capabilities',
            mno: 0,
            col: true,
            ti: '.Capabilities'
          }, {
            n: 'contact',
            mno: 0,
            col: true,
            ti: '.Contact'
          }, {
            n: 'documentation',
            mno: 0,
            col: true,
            ti: '.Documentation'
          }, {
            n: 'history',
            mno: 0,
            col: true,
            ti: '.History'
          }, {
            n: 'member',
            rq: true,
            col: true,
            ti: '.SensorML.Member'
          }, {
            n: 'version',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'version'
            },
            t: 'a'
          }]
      }, {
        ln: 'Parameters',
        tn: null,
        ps: [{
            n: 'parameterList',
            rq: true,
            en: 'ParameterList',
            ti: '.Parameters.ParameterList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SystemType',
        bti: '.AbstractComponentType',
        ps: [{
            n: 'components',
            ti: '.Components'
          }, {
            n: 'positions',
            ti: '.Positions'
          }, {
            n: 'connections',
            ti: '.Connections'
          }]
      }, {
        ln: 'ProcessMethodType',
        bti: 'GML_3_1_1.AbstractGMLType',
        ps: [{
            n: 'keywords',
            mno: 0,
            col: true,
            ti: '.Keywords'
          }, {
            n: 'identification',
            mno: 0,
            col: true,
            ti: '.Identification'
          }, {
            n: 'classification',
            mno: 0,
            col: true,
            ti: '.Classification'
          }, {
            n: 'validTime',
            ti: '.ValidTime'
          }, {
            n: 'securityConstraint',
            ti: '.SecurityConstraint'
          }, {
            n: 'legalConstraint',
            mno: 0,
            col: true,
            ti: '.LegalConstraint'
          }, {
            n: 'characteristics',
            mno: 0,
            col: true,
            ti: '.Characteristics'
          }, {
            n: 'capabilities',
            mno: 0,
            col: true,
            ti: '.Capabilities'
          }, {
            n: 'contact',
            mno: 0,
            col: true,
            ti: '.Contact'
          }, {
            n: 'documentation',
            mno: 0,
            col: true,
            ti: '.Documentation'
          }, {
            n: 'history',
            mno: 0,
            col: true,
            ti: '.History'
          }, {
            n: 'rules',
            rq: true,
            ti: '.ProcessMethodType.Rules'
          }, {
            n: 'algorithm',
            ti: '.ProcessMethodType.Algorithm'
          }, {
            n: 'implementation',
            mno: 0,
            col: true,
            ti: '.ProcessMethodType.Implementation'
          }]
      }, {
        ln: 'Connections.ConnectionList',
        tn: null,
        ps: [{
            n: 'connection',
            rq: true,
            col: true,
            ti: '.Connection'
          }]
      }, {
        ln: 'Interface',
        tn: null,
        ps: [{
            n: 'interfaceDefinition',
            rq: true,
            en: 'InterfaceDefinition',
            ti: '.InterfaceDefinition'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'SensorML.Member',
        tn: null,
        ps: [{
            n: 'process',
            rq: true,
            mx: false,
            dom: false,
            en: '_Process',
            ti: '.AbstractProcessType',
            t: 'er'
          }, {
            n: 'documentList',
            rq: true,
            en: 'DocumentList',
            ti: '.DocumentList'
          }, {
            n: 'contactList',
            rq: true,
            en: 'ContactList',
            ti: '.ContactList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ResponsibleParty',
        tn: null,
        ps: [{
            n: 'individualName'
          }, {
            n: 'organizationName'
          }, {
            n: 'positionName'
          }, {
            n: 'contactInfo',
            ti: '.ContactInfo'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }]
      }, {
        ln: 'ParametersPropertyType',
        tn: 'parametersPropertyType',
        ps: [{
            n: 'parameterList',
            rq: true,
            en: 'ParameterList',
            ti: '.AbstractListType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Classification',
        tn: null,
        ps: [{
            n: 'classifierList',
            rq: true,
            en: 'ClassifierList',
            ti: '.Classification.ClassifierList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Term',
        tn: null,
        ps: [{
            n: 'codeSpace',
            ti: 'SWE_1_0_1.CodeSpacePropertyType'
          }, {
            n: 'value',
            rq: true,
            ti: 'Token'
          }, {
            n: 'definition',
            an: {
              lp: 'definition'
            },
            t: 'a'
          }]
      }, {
        ln: 'RelaxNG',
        tn: null,
        bti: '.RuleLanguageType',
        ps: [{
            n: 'any',
            rq: true,
            mx: false,
            t: 'ae'
          }]
      }, {
        ln: 'DataSourceType',
        bti: '.AbstractProcessType',
        ps: [{
            n: 'dataDefinition',
            rq: true,
            ti: '.DataSourceType.DataDefinition'
          }, {
            n: 'values',
            rq: true,
            ti: '.DataSourceType.Values'
          }, {
            n: 'observationReference',
            rq: true,
            ti: '.DataSourceType.ObservationReference'
          }]
      }, {
        ln: 'Connection',
        tn: null,
        ps: [{
            n: 'link',
            rq: true,
            en: 'Link',
            ti: '.Link'
          }, {
            n: 'arrayLink',
            rq: true,
            en: 'ArrayLink',
            ti: '.ArrayLink'
          }, {
            n: 'name',
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ProcessMethodType.Implementation.ImplementationCode',
        tn: null,
        ps: [{
            n: 'description',
            en: {
              lp: 'description',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.StringOrRefType'
          }, {
            n: 'keywords',
            mno: 0,
            col: true,
            ti: '.Keywords'
          }, {
            n: 'identification',
            mno: 0,
            col: true,
            ti: '.Identification'
          }, {
            n: 'classification',
            mno: 0,
            col: true,
            ti: '.Classification'
          }, {
            n: 'validTime',
            ti: '.ValidTime'
          }, {
            n: 'securityConstraint',
            ti: '.SecurityConstraint'
          }, {
            n: 'legalConstraint',
            mno: 0,
            col: true,
            ti: '.LegalConstraint'
          }, {
            n: 'characteristics',
            mno: 0,
            col: true,
            ti: '.Characteristics'
          }, {
            n: 'capabilities',
            mno: 0,
            col: true,
            ti: '.Capabilities'
          }, {
            n: 'contact',
            mno: 0,
            col: true,
            ti: '.Contact'
          }, {
            n: 'documentation',
            mno: 0,
            col: true,
            ti: '.Documentation'
          }, {
            n: 'history',
            mno: 0,
            col: true,
            ti: '.History'
          }, {
            n: 'sourceRef',
            ti: '.ProcessMethodType.Implementation.ImplementationCode.SourceRef'
          }, {
            n: 'binaryRef',
            ti: '.ProcessMethodType.Implementation.ImplementationCode.BinaryRef'
          }, {
            n: 'language',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'language'
            },
            t: 'a'
          }, {
            n: 'framework',
            ti: 'Token',
            an: {
              lp: 'framework'
            },
            t: 'a'
          }, {
            n: 'version',
            ti: 'Token',
            an: {
              lp: 'version'
            },
            t: 'a'
          }]
      }, {
        ln: 'Rights',
        tn: null,
        ps: [{
            n: 'documentation',
            rq: true,
            ti: '.Documentation'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'privacyAct',
            ti: 'Boolean',
            an: {
              lp: 'privacyAct'
            },
            t: 'a'
          }, {
            n: 'intellectualPropertyRights',
            ti: 'Boolean',
            an: {
              lp: 'intellectualPropertyRights'
            },
            t: 'a'
          }, {
            n: 'copyRights',
            ti: 'Boolean',
            an: {
              lp: 'copyRights'
            },
            t: 'a'
          }]
      }, {
        ln: 'Event',
        tn: null,
        ps: [{
            n: 'date'
          }, {
            n: 'description',
            en: {
              lp: 'description',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.StringOrRefType'
          }, {
            n: 'keywords',
            mno: 0,
            col: true,
            ti: '.Keywords'
          }, {
            n: 'identification',
            mno: 0,
            col: true,
            ti: '.Identification'
          }, {
            n: 'classification',
            mno: 0,
            col: true,
            ti: '.Classification'
          }, {
            n: 'contact',
            mno: 0,
            col: true,
            ti: '.Contact'
          }, {
            n: 'documentation',
            mno: 0,
            col: true,
            ti: '.Documentation'
          }, {
            n: 'property',
            mno: 0,
            col: true,
            ti: 'SWE_1_0_1.DataComponentPropertyType'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }]
      }, {
        ln: 'Classification.ClassifierList.Classifier',
        tn: null,
        ps: [{
            n: 'term',
            rq: true,
            en: 'Term',
            ti: '.Term'
          }, {
            n: 'name',
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }]
      }, {
        ln: 'ArrayLink',
        tn: null,
        ps: [{
            n: 'sourceArray',
            rq: true,
            ti: '.ArrayLink.SourceArray'
          }, {
            n: 'destinationIndex',
            mno: 0,
            col: true,
            ti: '.ArrayLink.DestinationIndex'
          }, {
            n: 'destinationArray',
            rq: true,
            ti: '.ArrayLink.DestinationArray'
          }, {
            n: 'sourceIndex',
            ti: '.ArrayLink.SourceIndex'
          }, {
            n: 'connection',
            mno: 0,
            col: true,
            ti: '.Connection'
          }]
      }, {
        ln: 'ArrayLink.SourceIndex',
        tn: null,
        ps: [{
            n: 'ref',
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'Connections',
        tn: null,
        ps: [{
            n: 'connectionList',
            rq: true,
            en: 'ConnectionList',
            ti: '.Connections.ConnectionList'
          }]
      }, {
        ln: 'InputsPropertyType',
        tn: 'inputsPropertyType',
        ps: [{
            n: 'inputList',
            rq: true,
            en: 'InputList',
            ti: '.AbstractListType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'RuleLanguageType',
        tn: 'ruleLanguageType',
        ps: [{
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'MethodPropertyType',
        tn: 'methodPropertyType',
        ps: [{
            n: 'processMethod',
            rq: true,
            en: 'ProcessMethod',
            ti: '.ProcessMethodType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'EventList.Member',
        tn: null,
        ps: [{
            n: 'event',
            rq: true,
            en: 'Event',
            ti: '.Event'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Location',
        tn: null,
        ps: [{
            n: 'point',
            rq: true,
            en: {
              lp: 'Point',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.PointType'
          }, {
            n: 'curve',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: '_Curve',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.AbstractCurveType',
            t: 'er'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Link',
        tn: null,
        ps: [{
            n: 'source',
            rq: true,
            ti: '.Link.Source'
          }, {
            n: 'destination',
            rq: true,
            ti: '.Link.Destination'
          }, {
            n: 'type',
            an: {
              lp: 'type'
            },
            t: 'a'
          }]
      }, {
        ln: 'Person',
        tn: null,
        ps: [{
            n: 'surname',
            rq: true,
            ti: 'Token'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token'
          }, {
            n: 'userID',
            rq: true,
            ti: 'Token'
          }, {
            n: 'affiliation',
            rq: true,
            ti: 'Token'
          }, {
            n: 'phoneNumber',
            rq: true,
            ti: 'Token'
          }, {
            n: 'email',
            rq: true,
            ti: 'Token'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }]
      }, {
        ln: 'OutputsPropertyType',
        tn: 'outputsPropertyType',
        ps: [{
            n: 'outputList',
            rq: true,
            en: 'OutputList',
            ti: '.AbstractListType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Positions',
        tn: null,
        ps: [{
            n: 'positionList',
            rq: true,
            en: 'PositionList',
            ti: '.Positions.PositionList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'ContactInfo',
        tn: null,
        ps: [{
            n: 'phone',
            ti: '.ContactInfo.Phone'
          }, {
            n: 'address',
            ti: '.ContactInfo.Address'
          }, {
            n: 'onlineResource',
            mno: 0,
            col: true,
            ti: '.OnlineResource'
          }, {
            n: 'hoursOfService'
          }, {
            n: 'contactInstructions'
          }]
      }, {
        ln: 'Position',
        tn: null,
        ps: [{
            n: 'process',
            rq: true,
            mx: false,
            dom: false,
            en: '_Process',
            ti: '.AbstractProcessType',
            t: 'er'
          }, {
            n: 'position',
            rq: true,
            en: {
              lp: 'Position',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.PositionType'
          }, {
            n: 'vector',
            rq: true,
            en: {
              lp: 'Vector',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.VectorType'
          }, {
            n: 'name',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'name'
            },
            t: 'a'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Components',
        tn: null,
        ps: [{
            n: 'componentList',
            rq: true,
            en: 'ComponentList',
            ti: '.Components.ComponentList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Identification',
        tn: null,
        ps: [{
            n: 'identifierList',
            rq: true,
            en: 'IdentifierList',
            ti: '.Identification.IdentifierList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Security',
        tn: null,
        ps: [{
            n: 'classification',
            ti: 'IC_2_0.ClassificationType',
            an: {
              lp: 'classification',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'ownerProducer',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'ownerProducer',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'scIcontrols',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'SCIcontrols',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'sarIdentifier',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'SARIdentifier',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'disseminationControls',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'disseminationControls',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'fgIsourceOpen',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'FGIsourceOpen',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'fgIsourceProtected',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'FGIsourceProtected',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'releasableTo',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'releasableTo',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'nonICmarkings',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'nonICmarkings',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'classifiedBy',
            an: {
              lp: 'classifiedBy',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'classificationReason',
            an: {
              lp: 'classificationReason',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'derivedFrom',
            an: {
              lp: 'derivedFrom',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'declassDate',
            ti: 'Calendar',
            an: {
              lp: 'declassDate',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'declassEvent',
            an: {
              lp: 'declassEvent',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'declassException',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'declassException',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'typeOfExemptedSource',
            ti: {
              t: 'l'
            },
            an: {
              lp: 'typeOfExemptedSource',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'dateOfExemptedSource',
            ti: 'Calendar',
            an: {
              lp: 'dateOfExemptedSource',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }, {
            n: 'declassManualReview',
            ti: 'Boolean',
            an: {
              lp: 'declassManualReview',
              ns: 'urn:us:gov:ic:ism:v2'
            },
            t: 'a'
          }]
      }, {
        ln: 'ValidTime',
        tn: null,
        ps: [{
            n: 'timeInstant',
            rq: true,
            en: {
              lp: 'TimeInstant',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.TimeInstantType'
          }, {
            n: 'timePeriod',
            rq: true,
            en: {
              lp: 'TimePeriod',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.TimePeriodType'
          }]
      }, {
        ln: 'Link.Destination',
        tn: null,
        ps: [{
            n: 'ref',
            rq: true,
            ti: 'Token',
            an: {
              lp: 'ref'
            },
            t: 'a'
          }]
      }, {
        ln: 'ProcessModelType',
        bti: '.AbstractPureProcessType',
        ps: [{
            n: 'method',
            rq: true,
            ti: '.MethodPropertyType'
          }]
      }, {
        ln: 'SpatialReferenceFrame',
        tn: null,
        ps: [{
            n: 'engineeringCRS',
            rq: true,
            en: {
              lp: 'EngineeringCRS',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.EngineeringCRSType'
          }]
      }, {
        ln: 'Interfaces',
        tn: null,
        ps: [{
            n: 'interfaceList',
            rq: true,
            en: 'InterfaceList',
            ti: '.Interfaces.InterfaceList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Interfaces.InterfaceList',
        tn: null,
        ps: [{
            n: '_interface',
            rq: true,
            col: true,
            en: 'interface',
            ti: '.Interface'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'ContactInfo.Phone',
        tn: null,
        ps: [{
            n: 'voice',
            mno: 0,
            col: true
          }, {
            n: 'facsimile',
            mno: 0,
            col: true
          }]
      }, {
        ln: 'PresentationLayerPropertyType',
        ps: [{
            n: 'abstractDataRecord',
            rq: true,
            mx: false,
            dom: false,
            en: {
              lp: 'AbstractDataRecord',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.AbstractDataRecordType',
            t: 'er'
          }, {
            n: 'category',
            rq: true,
            en: {
              lp: 'Category',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.Category'
          }, {
            n: 'dataBlockDefinition',
            rq: true,
            en: {
              lp: 'DataBlockDefinition',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.DataBlockDefinitionType'
          }, {
            n: 'dataStreamDefinition',
            rq: true,
            en: {
              lp: 'DataStreamDefinition',
              ns: 'http:\/\/www.opengis.net\/swe\/1.0.1'
            },
            ti: 'SWE_1_0_1.DataStreamDefinitionType'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'Classification.ClassifierList',
        tn: null,
        ps: [{
            n: 'classifier',
            rq: true,
            col: true,
            ti: '.Classification.ClassifierList.Classifier'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id'
            },
            t: 'a'
          }]
      }, {
        ln: 'ContactList',
        tn: null,
        ps: [{
            n: 'description',
            en: {
              lp: 'description',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.StringOrRefType'
          }, {
            n: 'member',
            rq: true,
            col: true,
            ti: '.ContactList.Member'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }]
      }, {
        ln: 'Outputs',
        tn: null,
        ps: [{
            n: 'outputList',
            rq: true,
            en: 'OutputList',
            ti: '.Outputs.OutputList'
          }, {
            n: 'remoteSchema',
            an: {
              lp: 'remoteSchema',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }, {
            n: 'type',
            ti: 'XLink_1_0.TypeType',
            t: 'a'
          }, {
            n: 'href',
            t: 'a'
          }, {
            n: 'role',
            t: 'a'
          }, {
            n: 'arcrole',
            t: 'a'
          }, {
            n: 'title',
            t: 'a'
          }, {
            n: 'show',
            ti: 'XLink_1_0.ShowType',
            t: 'a'
          }, {
            n: 'actuate',
            ti: 'XLink_1_0.ActuateType',
            t: 'a'
          }]
      }, {
        ln: 'DocumentList',
        tn: null,
        ps: [{
            n: 'description',
            en: {
              lp: 'description',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            ti: 'GML_3_1_1.StringOrRefType'
          }, {
            n: 'member',
            rq: true,
            col: true,
            ti: '.DocumentList.Member'
          }, {
            n: 'id',
            ti: 'ID',
            an: {
              lp: 'id',
              ns: 'http:\/\/www.opengis.net\/gml'
            },
            t: 'a'
          }]
      }],
    eis: [{
        en: 'timePosition',
        ti: '.TimePosition'
      }, {
        en: 'InterfaceDefinition',
        ti: '.InterfaceDefinition'
      }, {
        en: 'ComponentArray',
        ti: '.ComponentArrayType',
        sh: '_Process'
      }, {
        en: 'legalConstraint',
        ti: '.LegalConstraint'
      }, {
        en: 'method',
        ti: '.MethodPropertyType'
      }, {
        en: 'classification',
        ti: '.Classification'
      }, {
        en: 'validTime',
        ti: '.ValidTime'
      }, {
        en: 'components',
        ti: '.Components'
      }, {
        en: 'connections',
        ti: '.Connections'
      }, {
        en: 'ruleLanguage',
        ti: '.RuleLanguageType'
      }, {
        en: 'securityConstraint',
        ti: '.SecurityConstraint'
      }, {
        en: 'contactInfo',
        ti: '.ContactInfo'
      }, {
        en: 'inputs',
        ti: '.Inputs'
      }, {
        en: 'positions',
        ti: '.Positions'
      }, {
        en: 'SensorML',
        ti: '.SensorML'
      }, {
        en: 'EventList',
        ti: '.EventList'
      }, {
        en: 'Event',
        ti: '.Event'
      }, {
        en: 'ProcessModel',
        ti: '.ProcessModelType',
        sh: '_Process'
      }, {
        en: 'DocumentList',
        ti: '.DocumentList'
      }, {
        en: 'DataSource',
        ti: '.DataSourceType',
        sh: '_Process'
      }, {
        en: 'history',
        ti: '.History'
      }, {
        en: 'ProcessMethod',
        ti: '.ProcessMethodType'
      }, {
        en: 'keywords',
        ti: '.Keywords'
      }, {
        en: 'contact',
        ti: '.Contact'
      }, {
        en: 'Component',
        ti: '.ComponentType',
        sh: '_Process'
      }, {
        en: 'Link',
        ti: '.Link'
      }, {
        en: 'location',
        ti: '.Location'
      }, {
        en: 'Rights',
        ti: '.Rights'
      }, {
        en: 'spatialReferenceFrame',
        ti: '.SpatialReferenceFrame'
      }, {
        en: '_Process',
        ti: '.AbstractProcessType'
      }, {
        en: 'ResponsibleParty',
        ti: '.ResponsibleParty'
      }, {
        en: 'Document',
        ti: '.Document'
      }, {
        en: 'schematron',
        ti: '.Schematron',
        sh: 'ruleLanguage'
      }, {
        en: 'Person',
        ti: '.Person'
      }, {
        en: 'ArrayLink',
        ti: '.ArrayLink'
      }, {
        en: 'onlineResource',
        ti: '.OnlineResource'
      }, {
        en: 'capabilities',
        ti: '.Capabilities'
      }, {
        en: 'interfaces',
        ti: '.Interfaces'
      }, {
        en: 'interface',
        ti: '.Interface'
      }, {
        en: 'temporalReferenceFrame',
        ti: '.TemporalReferenceFrame'
      }, {
        en: 'characteristics',
        ti: '.Characteristics'
      }, {
        en: 'identification',
        ti: '.Identification'
      }, {
        en: 'Term',
        ti: '.Term'
      }, {
        en: 'outputs',
        ti: '.Outputs'
      }, {
        en: 'parameters',
        ti: '.Parameters'
      }, {
        en: 'ContactList',
        ti: '.ContactList'
      }, {
        en: 'connection',
        ti: '.Connection'
      }, {
        en: 'Security',
        ti: '.Security'
      }, {
        en: 'System',
        ti: '.SystemType',
        sh: '_Process'
      }, {
        en: 'ProcessChain',
        ti: '.ProcessChainType',
        sh: '_Process'
      }, {
        en: 'documentation',
        ti: '.Documentation'
      }, {
        en: 'relaxNG',
        ti: '.RelaxNG',
        sh: 'ruleLanguage'
      }, {
        en: 'position',
        ti: '.Position'
      }]
  };
  return {
    SensorML_1_0_1: SensorML_1_0_1
  };
};
if (typeof define === 'function' && define.amd) {
  define([], SensorML_1_0_1_Module_Factory);
}
else {
  var SensorML_1_0_1_Module = SensorML_1_0_1_Module_Factory();
  if (typeof module !== 'undefined' && module.exports) {
    module.exports.SensorML_1_0_1 = SensorML_1_0_1_Module.SensorML_1_0_1;
  }
  else {
    var SensorML_1_0_1 = SensorML_1_0_1_Module.SensorML_1_0_1;
  }
}